module.exports = __webpack_public_path__ + "assets/img/amphora.7d55476b.png";